import React, { useEffect, useState } from "react"
import * as classNames from "./MegaMenu.module.scss"
import Button from "../../../../../lib/common/blocks/button/Button"
import Icon from "../../../../../lib/common/blocks/icon/Icon"
import MegaMenuCard from "./mega-menu-card/MegaMenuCard"
import { site } from "../../../../../../utils/site"
import Axios from "axios"
import DebouncedAxios from "../../../../../../utils/debouncedAxios"
import MegaMenuSearchResultsCol from "./mega-menu-search-results-col/MegaMenuSearchResultsCol"
import { isMobileDevice } from "../../../../../../utils/isDevice"
// import { site } from "../../../../../../utils/site" 
const MegaMenu = ({
  name = "",
  data = [],
  term = "",
  card = [],
  isMegaMenuActive,
  triggerParentUpdate,
}) => {
  const [isMegaSubMenuActive, setMegaSubMenuActive] = useState({})
  const handleClick = () => {
    triggerParentUpdate()
  }
  const handleClick2 = (index) => {
    setMegaSubMenuActive((isMegaSubMenuActive) => ({
      ...isMegaSubMenuActive,
      [index]: !isMegaSubMenuActive[index],
    }))
  }

  const getSearchUrl = () => {
    switch (site) {
      case "rh":
        return "/annonces/"
      default:
        return "/search/"
    }
  }

  const renderColItems = (data) => {
    return data.map((item, index) => {
      const {
        route = "",
        label = "",
        visibility = true,
        subTitle = "",
        children = [],
        products = [],
        currentProducts = [],
      } = item || {}
      return (
        visibility && (
          <li key={index}>
            <Button
              aspect="unstyled"
              color="unstyled"
              size="large"
              className={classNames.megaMenuItemLink}
              activeclassname={classNames.active}
              ctalink={route}
              onClick={() => {
                if (!route) {
                  handleClick()
                }
              }}
            >
              <span>{label}</span>
              {!isMobileDevice() && subTitle && (
                <span
                  className={`line-clamp-2 ${classNames.megaMenuItemSubTitle}`}
                >
                  {subTitle}
                </span>
              )}
              {!route && (children?.length > 0 || products?.length > 0) && (
                <Icon
                  icon="arrowRight"
                  color="var(--secondary-color)"
                  className="xs-inline-flex lg-none ml-auto"
                />
              )}
            </Button>
            {route && (children?.length > 0 || products?.length > 0) && (
              <Button
                aspect="unstyled"
                color="unstyled"
                className="xs-inline-flex lg-none ml-auto"
                onClick={() => handleClick2(index)}
              >
                <Icon
                  icon="arrowRight"
                  color="var(--secondary-color)"
                />
              </Button>
            )}
            {currentProducts?.length > 0 && (
              <ul
                className={`${classNames.megaMenuSubItemsProducts} 
                ${isMegaSubMenuActive ? classNames.subMenuActive : ""}`}
              >
                {currentProducts.map((currentProduct, i) => {
                  return (
                    <li key={index}>
                      <Button
                        aspect="unstyled"
                        color="unstyled"
                        ctalink={currentProduct.route}
                        activeclassname={classNames.active}
                      >
                        {currentProduct.label}
                      </Button>
                    </li>
                  )
                })}
              </ul>
            )}
            {children?.length > 0 && (
              <ul>
                {children.map((child, i) => {
                  return (
                    <li key={i}>
                      <Button
                        aspect="unstyled"
                        color="unstyled"
                        ctalink={child.route}
                        activeclassname={classNames.active}
                      >
                        {child.label}
                      </Button>
                      {child.products?.length > 0 && (
                        <ul>
                          {child.products.map((product, i) => {
                            return (
                              <li key={i}>
                                <Button
                                  aspect="unstyled"
                                  color="unstyled"
                                  ctalink={product.route}
                                  activeclassname={classNames.active}
                                >
                                  {product.label}
                                </Button>
                              </li>
                            )
                          })}
                        </ul>
                      )}
                    </li>
                  )
                })}
              </ul>
            )}
            {products?.length > 0 && (
              <ul
                className={`${classNames.megaMenuSubItemsProducts} 
              ${isMegaSubMenuActive[index] ? classNames.subMenuActive : ""}`}
              >
                <li
                  key={label}
                  className={`${classNames.megaMenuTitle}
                  ${"xs-block lg-none"}`}
                >
                  <Button
                    aspect="unstyled"
                    color="unstyled"
                    className={"xs-inline-flex lg-none"}
                    onClick={() => handleClick2(index)}
                  >
                    <Icon
                      icon="arrowLeft"
                      color="secondary"
                      width="22"
                      height="22"
                    />
                    <span>{label}</span>
                  </Button>
                </li>
                {products.map((product, i) => {
                  return (
                    <li key={i}>
                      <Button
                        aspect="unstyled"
                        color="unstyled"
                        ctalink={product.route}
                        activeclassname={classNames.active}
                      >
                        {product.label}
                      </Button>
                    </li>
                  )
                })}
              </ul>
            )}
          </li>
        )
      )
    })
  }
  const renderSearchResults = (term) => {
    return (
      <li className="flex w-100 gap-7">
        <DebouncedAxios
          url={process.env.GATSBY_NEST_BASE_URL + "/search"}
          params={{ site, q: term }}
        >
          {({ loading, error, data = [] }) => {
            const config = {
              rh: {
                leftColLabel: "Poste",
                leftColCollectionName: "Annonces",
                leftColLinkLabel: "Voir les annonces",
                leftColLinkLabelEmpty: "Toutes les annonces",
                rightColLabel: "Article",
                rightColLinkLabel: "Voir les articles",
                rightColLinkLabelEmpty: "Toutes les annonces",
                url: "/annonces?q=",
                articleUrl:"/travailler-chez-paritel"
              },
              blog: {
                leftColLabel: "Article",
                leftColCollectionName: "Articles",
                leftColLinkLabel: "Voir les articles",
                leftColLinkLabelEmpty: "Tous les articles",
                rightColLabel: "Tag",
                rightColLinkLabel: "Voir les articles",
                rightColLinkLabelEmpty: "Tous les articles",
                url: "/search?q=",
              },
              grp: {
                leftColLabel: "Article",
                leftColCollectionName: "page",
                leftColLinkLabel: "Tous les articles",
                rightColLabel: "Tag",
                rightColLinkLabel: "Voir les articles",
                rightColLinkLabelEmpty: "Tous les articles",
                url: "/search?q=",
              },
            }

            const leftColAllData =
              data[config[site]?.leftColCollectionName] || []

            let rightColAllData = []
            Object.keys(data).forEach((key) => {
              if (key === config[site]?.leftColCollectionName) {
                return
              }

              rightColAllData = rightColAllData.concat(data[key])
            })

            return (
              <>
                <MegaMenuSearchResultsCol
                  label={config[site]?.leftColLabel}
                  count={leftColAllData.length}
                  data={leftColAllData.slice(0, 2)}
                  linkLabel={config[site]?.leftColLinkLabel}
                  linkLabelEmpty={config[site]?.leftColLinkLabelEmpty}
                  url={config[site]?.url}
                  term={term}
                  articleUrl={config[site]?.articleUrl}
                ></MegaMenuSearchResultsCol>

                <MegaMenuSearchResultsCol
                  label={config[site]?.rightColLabel}
                  count={rightColAllData.length}
                  data={rightColAllData.slice(0, 2)}
                  linkLabel={config[site]?.rightColLinkLabel}
                  linkLabelEmpty={config[site]?.rightColLinkLabelEmpty}
                  url={config[site]?.url}
                  term={term}
                  articleUrl={config[site]?.articleUrl}
                ></MegaMenuSearchResultsCol>
              </>
            )
          }}
        </DebouncedAxios>
      </li>
    )
  }
  const [suggestions, setSuggestions] = useState([])
  useEffect(() => {
    async function fetchSuggestions() {
      try {
        if (term && term.length > 1) {
          const rep = await Axios.get(
            `${process.env.GATSBY_NEST_BASE_URL}/search/suggest/?site=${site}&q=${term}`
          )

          console.log("rep", rep)

          setSuggestions(rep.data.suggestions)
        } else {
          setSuggestions([])
        }
      } catch (error) {
        console.error("Error while calling /search/suggest/:", error)
      }
    }
    fetchSuggestions()
  }, [term])
  return (
    <ul
      className={`${
        (card && card.length !== 0) || name === "search"
          ? classNames.megaMenuhasCard
          : classNames.megaMenu
      } ${isMegaMenuActive ? classNames.active : ""}`}
    >
      <li
        key={name}
        className={`${classNames.megaMenuTitle} ${classNames.megaMenuItems}
        ${"xs-block lg-none"}`}
      >
        <Button
          aspect="unstyled"
          color="unstyled"
          className={"xs-inline-flex lg-none"}
          onClick={handleClick}
        >
          <Icon
            icon="arrowLeft"
            color="secondary"
            width="22"
            height="22"
          />
          <span>{name}</span>
        </Button>
      </li>
      <li className={classNames.megaMenuItems}>
        {name === "search" ? (
          <ul className={`flex items-center h-100`}>
            {renderSearchResults(term)}
          </ul>
        ) : (
          <ul className={classNames.columns}>{renderColItems(data)}</ul>
        )}
      </li>
      <li className={classNames.cardContainer}>
        <ul className={!card ? classNames.megaMenuItems : ""}>
          {name === "search" ? (
            suggestions.length > 0 ? (
              <>
                <li className="mb-2 min-3">
                  <strong>Suggestions :</strong>
                </li>
                {suggestions.map((s) => {
                  return (
                    <li
                      key={s.term}
                      className="pbl-2 pin-3"
                    >
                      <Button
                        aspect="unstyled"
                        to={encodeURI("/search?q=" + s.term)}
                      >
                        {s.term}
                      </Button>
                    </li>
                  )
                })}
              </>
            ) : (
              <>
                <li className="mb-2 min-3">
                  <strong>Recherches fréquentes :</strong>
                </li>
                {site === "rh" ? (
                  <>
                    <li className="pbl-2 pin-3">
                      <Button
                        aspect="unstyled"
                        to={getSearchUrl() + "?q=commercial"}
                      >
                        commercial
                      </Button>
                    </li>
                    <li className="pbl-2 pin-3">
                      <Button
                        aspect="unstyled"
                        to={getSearchUrl() + "?q=technicien"}
                      >
                        technicien
                      </Button>
                    </li>
                  </>
                ) : (
                  <>
                    {" "}
                    <li className="pbl-2 pin-3">
                      <Button
                        aspect="unstyled"
                        to={getSearchUrl() + "?q=cybersécurité"}
                      >
                        cybersécurité
                      </Button>
                    </li>
                    <li className="pbl-2 pin-3">
                      <Button
                        aspect="unstyled"
                        to={getSearchUrl() + "?q=fibre"}
                      >
                        fibre
                      </Button>
                    </li>
                    <li className="pbl-2 pin-3">
                      <Button
                        aspect="unstyled"
                        to={getSearchUrl() + "?q=5G"}
                      >
                        5G
                      </Button>
                    </li>
                  </>
                )}
              </>
            )
          ) : (
            card && (
              <li>
                <MegaMenuCard card={card} />
              </li>
            )
          )}
        </ul>
      </li>
    </ul>
  )
}

export default MegaMenu
